// 🚨 AUTO-GENERADO desde CreditnoteDataType.ts - No editar manualmente

export const CreditnoteFormDataKeys = [
  "id",
  "numero",
  "sequence",
  "document_key",
  "need_assignment",
  "description",
  "email",
  "subtotal",
  "discountCode",
  "descuento",
  "impuestos",
  "impuestos_servicio",
  "total",
  "exchange_rate",
  "edocument_status",
  "edocument_status_payload",
  "created",
  "activitycode",
  "selected_logo",
  "excludeFromReport",
  "price_note",
  "anulada",
  "info_references",
  "otros_cargos",
  "pending_submission",
  "pending_submission_attempts",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "invoiceId",
  "invoice",
  "buyInvoiceId",
  "appliedInvoiceId",
  "appliedInvoice",
  "creditnoteProducts",
  "user",
  "reference_number"
] as const;
